import React, { useState } from 'react';

import { Flex, Icon, List, ListItem, Stack } from '@chakra-ui/react';
import { FormikErrors } from 'formik';
import Link from 'next/link';
import { HiTrash } from 'react-icons/hi';

import { CustomText } from '@components/Custom-text';

interface UploadedFilesProps {
    name: string;
    files: File[];
    setFiles: React.Dispatch<React.SetStateAction<File[]>>;
    selectedFiles?: string[];
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean | undefined
    ) => Promise<void | FormikErrors<any>>;
    setFileIds: React.Dispatch<React.SetStateAction<string[]>>;
}

const UploadedFiles: React.FC<UploadedFilesProps> = ({
    name,
    files,
    setFiles,
    selectedFiles,
    setFieldValue,
    setFileIds,
}) => {
    const [uploadedFiles, setUploadedFiles] = useState<string[]>(selectedFiles!);

    const removeUploadedFile = (file: string) => {
        const localUplaodedFiles = uploadedFiles.filter(fileId => fileId !== file);
        setUploadedFiles(localUplaodedFiles);
    };

    const removeFile = (index: number) => {
        const localFiles = files;
        localFiles.splice(index, 1);
        setFiles([...localFiles]);
    };
    return (
        <Stack>
            <Flex>
                {uploadedFiles && uploadedFiles.length > 0 && (
                    <List>
                        {uploadedFiles.map((file, index) => (
                            <ListItem key={index} marginBottom={3}>
                                <Flex gap={5} alignItems="center">
                                    <Link href={file}>
                                        <CustomText size="md" color="primary.light">
                                            {decodeURIComponent(file.replace(/.+-(.+)/g, '$1'))}
                                        </CustomText>
                                    </Link>
                                    <Icon
                                        as={HiTrash}
                                        color="red"
                                        fontSize={20}
                                        cursor="pointer"
                                        onClick={() => {
                                            removeUploadedFile(file);
                                            setFileIds(prevIds => [...prevIds, file]);
                                        }}
                                    />
                                </Flex>
                            </ListItem>
                        ))}
                    </List>
                )}
            </Flex>
            <Flex>
                <List>
                    {files.map((file, index) => (
                        <ListItem key={index} marginBottom={3}>
                            <Flex gap={5} alignItems="center">
                                <CustomText size="md" color="primary.light">
                                    {file.name}
                                </CustomText>
                                <Icon
                                    as={HiTrash}
                                    color="red"
                                    fontSize={20}
                                    cursor="pointer"
                                    onClick={() => {
                                        removeFile(index);
                                        setFieldValue(name, [...files]);
                                    }}
                                />
                            </Flex>
                        </ListItem>
                    ))}
                </List>
            </Flex>
        </Stack>
    );
};

export default UploadedFiles;
